import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@bt/shared';
import {NgSelectizeModule} from 'ng-selectize';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BinanceComponent } from './binance.component';

@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      SharedModule,
      NgSelectizeModule,
      FontAwesomeModule
    ],
    declarations: [
      BinanceComponent,
    ],
  })
  export class BinanceModule { }


// WEBPACK FOOTER //
// ./src/app/binance/binance.module.ts